var exitModal = (function () {
  function init() {
    uiBindings();
  }

  var uiBindings = function () {
    /**
     * Function to Create Cookies with Path.
     */
    function createCookieWithPath(name, value, days) {
      var expires;
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
      } else {
        expires = "";
      }
      var secure = "";
      if (location.protocol.match(/https/)) {
        secure = ";secure";
      }
      document.cookie =
        name +
        "=" +
        value +
        expires +
        "; path=" +
        window.location.pathname +
        ";" +
        secure;
    }
    window.addEventListener("load", function () {
      //exit intent modal
      var exitModal = document.getElementById("exit-window-modal");

      // Open Exit Modal only on Desktop
      if (exitModal && window.innerWidth > 980) {
        exitModal.classList.contains("exit-window-modal-experiment-show")
          ? WebEventTracker.logEvent(EDS.webEvents, exitModalEvents.interact, {
              action: exitModalEvents.experiment,
              showModal: true,
            })
          : "";

        exitModal.classList.contains("exit-window-modal-experiment-hide")
          ? WebEventTracker.logEvent(EDS.webEvents, exitModalEvents.interact, {
              action: exitModalEvents.experiment,
              showModal: false,
            })
          : "";

        // if cursor leaves the current window
        document.addEventListener("mouseout", function (e) {
          if (e.clientY < 1) {
            var exitModal = document.getElementById("exit-window-modal");
            var isModalExperiment = exitModal.classList.contains(
              "exit-window-modal-experiment-show"
            );
            var hideExitModal = exitModal.classList.contains(
              "exit-window-modal-experiment-hide"
            );
            if (
              ((!isModalExperiment && !Cookie.read("closeExitModal")) ||
                (isModalExperiment && !Cookie.read("closeExitModal-2"))) &&
              !document.body.classList.contains("tingle-enabled") &&
              !hideExitModal
            ) {
              //Add cookie to count load window expiry 30 days
              var countExitModal = isModalExperiment
                ? Cookie.read("countExitModal-2")
                : Cookie.read("countExitModal");

              //check if cookie exists
              if (countExitModal == null) {
                isModalExperiment
                  ? createCookieWithPath("countExitModal-2", "1", 30)
                  : Cookie.create("countExitModal", "1", 30);
              } else if (countExitModal == 1) {
                //check cookie count
                isModalExperiment
                  ? createCookieWithPath("closeExitModal-2", "1", 30)
                  : Cookie.create("closeExitModal", "1", 30);

                //delete count cookie
                isModalExperiment
                  ? createCookieWithPath("countExitModal-2", "", -1)
                  : Cookie.erase("countExitModal");
              }

              //Load amplitude event
              WebEventTracker.logEvent(
                EDS.webEvents,
                exitModalEvents.interact,
                {
                  action: exitModalEvents.load,
                }
              );

              var exitModalContent = document.getElementById(
                "exit-modal-popup"
              );
              if (exitModalContent) {
                var exitModal = new tingle.modal({
                  closeIconInverse: exitModalContent.dataset.closeIconInverse ? true : false,
                  onOpen: function () {
                    var tingleModal = document.getElementById(
                      "tingle-modal-box"
                    );
                    tingleModal.setAttribute("style", "width:auto !important;");

                    //Click CTA event to add cookie closeExitModal
                    var exitModalCTA = document.getElementById("exit-window-modal-cta-btn");
                    if (exitModalCTA) {
                      exitModalCTA.addEventListener("click", function (e) {
                        // Click Exit Modal CTA
                        WebEventTracker.logEvent(
                          EDS.webEvents,
                          exitModalEvents.interact,
                          {
                            action: exitModalEvents.click,
                          }
                        );

                        var isModalExperiment = exitModal.classList.contains(
                          "exit-window-modal-experiment-show"
                        );
                        isModalExperiment
                          ? createCookieWithPath("closeExitModal-2", "1", 30)
                          : Cookie.create("closeExitModal", "1", 30);

                        //delete count cookie
                        isModalExperiment
                          ? createCookieWithPath("countExitModal-2", "", -1)
                          : Cookie.erase("countExitModal");
                      });
                    }

                    //Click secondary CTA event to add cookie closeExitModal
                    var cancelCTA = document.getElementById("exit-window-modal-cancel-btn");
                    if (cancelCTA) {
                      cancelCTA.addEventListener("click", function(e) {
                        // Close amplitude event
                        WebEventTracker.logEvent(
                          EDS.webEvents,
                          exitModalEvents.interact,
                          {
                            action: exitModalEvents.close,
                          }
                        );

                        Cookie.create("closeExitModal", "1", 30);

                        /*
                        * close modal without call close function. because on close its fire amplitude to avoid duplicate 
                        */
                        var elements = document.getElementsByClassName("tingle-modal--visible");
                        while (elements.length > 0) elements[0].remove();

                        //remove from body class
                        document.body.className = document.body.className.replace("tingle-enabled","");
                      });
                    }
                  },
                  onClose: function () {
                    //add cookie with 30 day expiry
                    isModalExperiment
                      ? createCookieWithPath("closeExitModal-2", "1", 30)
                      : Cookie.create("closeExitModal", "1", 30);

                    //delete count cookie
                    isModalExperiment
                      ? createCookieWithPath("countExitModal-2", "", -1)
                      : Cookie.erase("countExitModal");

                    // Close amplitude event
                    WebEventTracker.logEvent(
                      EDS.webEvents,
                      exitModalEvents.interact,
                      {
                        action: exitModalEvents.close,
                      }
                    );

                    exitModal.destroy();
                  },
                });
                exitModal.setContent(exitModalContent.innerHTML);
                exitModal.open();
              }
            }
          }
        });
      }
    });
  };

  init();
})();
